/**
 * AppShell
 *
 * Owns the collapse state for the sidebar (since RootLayout is a server
 * component and useState would force a client boundary anyway). Composes:
 *
 *   ┌───────────────────────────────────────────────┐
 *   │ Sidebar │  Topbar                              │
 *   │         │  DisruptionBanner (cond.)            │
 *   │         │  ─────────────────────────────────── │
 *   │         │  <main> children </main>             │
 *   └───────────────────────────────────────────────┘
 *
 * Stage FW-1 update: on /login, render children WITHOUT sidebar/topbar.
 */

import { useState, type ReactNode } from 'react';
import { useLocation } from 'react-router';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { DisruptionBanner } from './DisruptionBanner';

export function AppShell({ children }: { children: ReactNode }) {
  const [collapsed, setCollapsed] = useState(false);
  const { pathname } = useLocation();

  // On /login, render children without shell chrome
  if (pathname === '/login') {
    return <>{children}</>;
  }

  return (
    <div className="flex h-screen overflow-hidden bg-background text-foreground">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar />
        <DisruptionBanner />
        <main className="flex-1 overflow-y-auto">
          <div className="mx-auto w-full max-w-[1400px] px-8 py-8">{children}</div>
        </main>
      </div>
    </div>
  );
}
